<template>
  <r-panel :title="title" :button_add="true" @click_add="click_add">
    <mapkind-table ref="table" :items.sync="values" :title="title" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {MapKindLiteModel} from "@/modules/mutils/models/MapKindLiteModel";
import RPanel from "@/modules/redactor/views/utils/r-panel";
import mapkindTable from "./mapkind-table.vue";

export default {
  name: "mapkind-panel",
  components: {RPanel, mapkindTable},
  props: {
    title: VueTypes.string.def("MapKinds"),
    items: {
      type: Array,
      required: true,
      default: () => [],
      validator: function(value) {
        return Array.isArray(value);
      }
    }
  },
  computed: {
    values() {
      if (this.items && Array.isArray(this.items)) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}
</script>